var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C11.6355 15 15 11.6355 15 7.5C15 3.3645 11.6355 0 7.5 0ZM7.5 13.5C4.19175 13.5 1.5 10.8083 1.5 7.5C1.5 4.19175 4.19175 1.5 7.5 1.5C10.8082 1.5 13.5 4.19175 13.5 7.5C13.5 10.8083 10.8082 13.5 7.5 13.5Z",
    fill: "#8D8E92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87617 6.75C5.49749 6.75 6.00117 6.24632 6.00117 5.625C6.00117 5.00368 5.49749 4.5 4.87617 4.5C4.25485 4.5 3.75117 5.00368 3.75117 5.625C3.75117 6.24632 4.25485 6.75 4.87617 6.75Z",
    fill: "#8D8E92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1198 6.7395C10.7382 6.7395 11.2395 6.23817 11.2395 5.61975C11.2395 5.00133 10.7382 4.5 10.1198 4.5C9.50133 4.5 9 5.00133 9 5.61975C9 6.23817 9.50133 6.7395 10.1198 6.7395Z",
    fill: "#8D8E92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50059 12.0001C11.2506 12.0001 12.0006 8.25007 12.0006 8.25007H3.00059C3.00059 8.25007 3.75059 12.0001 7.50059 12.0001Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.1c5596f5c5d2e795739be06df185dc9b.svg";
export { ForwardRef as ReactComponent };